import { Sidebar } from './Sidebar';
import { TravelerBottomNav } from './TravelerBottomNav';
import { NotificationBell } from './NotificationBell';
import { usePlayer } from '../../contexts/PlayerContext';

export function DashboardLayout({ children, type = 'admin' }) {
    const player = usePlayer();
    const isTraveler = type === 'traveler';
    const isOperator = type === 'operator';

    return (
        <div className="min-h-screen bg-[#0A0D14] flex">
            <Sidebar type={type} />
            <main className="flex-1 min-h-screen overflow-auto">
                {isOperator && (
                    <div className="fixed top-3 right-4 z-50 lg:absolute lg:top-6 lg:right-8">
                        <NotificationBell />
                    </div>
                )}
                <div className={`p-4 lg:p-8 ${isTraveler ? 'pt-4 lg:pt-8' : 'pt-16 lg:pt-8'} ${
                    isTraveler
                        ? (player.isActive ? 'pb-40 lg:pb-8' : 'pb-24 lg:pb-8')
                        : (player.isActive ? 'pb-24' : '')
                }`}>
                    {children}
                </div>
            </main>
            {isTraveler && <TravelerBottomNav />}
        </div>
    );
}
